export default [
    {
        type: "special",
        id: 1,
        items: [
            {
                id: 1,
                text: "Ich wurde auf den Workshop aufmerksam durch",
                label: [
                    {
                        id: 1,
                        text: "ISZ Info-Mail",
                    },
                    {
                        id: 2,
                        text: "Facebook-Seite der UdS",
                    },
                    {
                        id: 3,
                        text: "Schlüsselkompetenzen-Programm Homepage",
                    },
                    {
                        id: 4,
                        text: "ISZ Homepage",
                    },
                    {
                        id: 5,
                        text: "Andere Wege, nämlich",
                    },
                ],
            },
        ],
    },
    {
        type: "text",
        id: 2,
        items: [
            {
                id: 2,
                text: "Andere:",
                type: "medium",
            },
        ],
    },
    {
        type: "special",
        id: 3,
        items: [
            {
                id: 3,
                text: "Ich bin",
                label: [
                    {
                        id: 1,
                        text: "Bachelor-Studierende/r",
                    },
                    {
                        id: 2,
                        text: "Master-Studierende/r",
                    },
                    {
                        id: 3,
                        text: "Mitarbeiter/in",
                    },
                    {
                        id: 4,
                        text: "Lehrende/r",
                    },
                ],
            },
        ],
    },
    {
        type: "text",
        id: 4,
        items: [
            {
                id: 4,
                text: "Hauptfach/Fachstudiengang",
                type: "medium",
            },
            {
                id: 5,
                text: "Semesterzahl (falls Studierende/r)",
                type: "small",
            },
            {
                id: 6,
                text: "Angestrebter Abschluss (falls Studierende/r)",
                type: "medium",
            },
        ],
    },
    {
        type: "uni",
        id: 5,
        items: [
            {
                id: 7,
                text: "Der Umfang des Kurses (Dauer, Anzahl der Stunden) war genau richtig.",
            },
            {
                id: 8,
                text: "Der Umfang des behandelten Stoffes war genau richtig.",
            },
            {
                id: 9,
                text: "Das Tempo des Kurses war genau richtig.",
            },
            {
                id: 10,
                text: "Der Schwierigkeitsgrad des Kurses (Inhalte und Aufgaben) war genau richtig.",
            },
            {
                id: 11,
                text: "Der Arbeitsaufwand des Kurses war genau richtig.",
            },
            {
                id: 12,
                text: "Die Aufgaben und Übungen waren klar und verständlich formuliert.",
            },
            {
                id: 13,
                text: "Das Sprachnivau war genau richtig. Ich konnte dem Kurs sprachlich gut folgen.",
            },
            {
                id: 14,
                text: "Ich habe verstanden, was das Ziel des Kurses war.",
            },
            {
                id: 15,
                text: "Der Kurs war gut gegliedert. Die Reihenfolge der Inhalte war logisch und sinnvoll.",
            },
            {
                id: 16,
                text: "Das Verhältnis zwischen Theorie und Praxis war ausgeglichen.",
            },
            {
                id: 17,
                text: "Die praktische Bedeutung der Themen ist deutlich geworden.",
            },
            {
                id: 18,
                text: "Das Verhältnis zwischen Einzel- und Gruppenarbeit war sinnvoll.",
            },
            {
                id: 19,
                text: "In dem Kurs wurden für mich die richtigen Schwerpunkte gesetzt.",
            },
            {
                id: 20,
                text: "Die Übungen und Aufgaben motivierten mich, mitzudenken und mich aktiv am Kurs zu beteiligen.",
            },
            {
                id: 21,
                text: "Die Übungen und Aufgaben haben mir geholfen, das Thema besser zu verstehen.",
            },
            {
                id: 22,
                text: "Die Lehrperson war engagiert und motiviert.",
            },
            {
                id: 23,
                text: "Die Lehrperson ermöglichte eine gute Lern- und Arbeitsatmosphäre.",
            },
            {
                id: 24,
                text: "Die Lehrperson war gut vorbereitet.",
            },
            {
                id: 25,
                text: "Die Lehrperson war flexibel und hat auf die Wünsche und Bedürfnisse der Teilnehmenden gut reagiert.",
            },
            {
                id: 26,
                text: "Die Lehrperson war fachlich kompetent.",
            },
            {
                id: 27,
                text: "Die Lehrperson konnte gut erklären.",
            },
            {
                id: 28,
                text: "Die Lehrperson hat mich motiviert, mitzuarbeiten, zu diskutieren und Fragen zu stellen.",
            },
            {
                id: 29,
                text: "Die Lehrperson hat bei der Bearbeitung der Aufgaben und Übungen geholfen, wenn es erforderlich war.",
            },
            {
                id: 30,
                text: "Der Kurs war für mein Studium nützlich und sinnvoll.",
            },
            {
                id: 31,
                text: "Der Kurs war für meine persönliche Entwicklung hilfreich.",
            },
            {
                id: 32,
                text: "Ich hatte Gelegenheit, meine Themen und Anliegen zu reflektieren.",
            },
            {
                id: 33,
                text: "Durch den Kurs habe ich Kenntnisse gewonnen und Kompetenzen (weiter-) entwickelt, die ich (in Studium, Alltag und Beruf) praktisch anwenden kann.",
            },
            {
                id: 34,
                text: "Ich kann jetzt das Thema selbstständig weiterbearbeiten.",
            },
            {
                id: 35,
                text: "Meine Erwartungen an die Veranstaltung wurden erfüllt.",
            },
            {
                id: 36,
                text: "Insgesamt fand ich die Veranstaltung gut.",
            },
            {
                id: 37,
                text: "Ich würde die Veranstaltung weiterempfehlen.",
            },
        ],
    },
    {
        type: "text",
        id: 6,
        items: [
            {
                id: 38,
                text: "Was war besonders gut? Was hat Ihnen gefallen? Was soll so bleiben?",
            },
            {
                id: 39,
                text: "Was war nicht gut? Was hat Ihnen nicht gefallen? Was sollte geändert werden?",
            },
            {
                id: 40,
                text: "Vermissen Sie einen Kurs in unserem Angebot? Wir freuen uns über Ihre Vorschläge!",
            },
        ],
    },
];